import { ApiService, USER_KEY } from "./api.service";
import axios from "axios";

export default class AuthService extends ApiService {
  login(user) {
    return this.post(user, "site/login").then((response) => {
      if (response["auth_key"]) {
        localStorage.setItem(USER_KEY, JSON.stringify(response));
      }

      return response.data;
    });
  }

  loginViaToken(authKey) {
    return this.get({ authKey }, "site/login-via-token").then((response) => {
      if (response["auth_key"]) {
        localStorage.setItem(USER_KEY, JSON.stringify(response));
      }

      return response.data;
    });
  }

  logout() {
    localStorage.removeItem(USER_KEY);
  }

  register(user) {
    return axios.post(this.endpoint + "site/signup", user);
  }
  type() {
    return axios.get(this.endpoint + "types?realm=2");
  }

  notifications() {
    return this.get({ expand: "userName,action", sort: "-id" }, "notifications/all");
  }
}
